// src/App.js
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './Pages/HomePage';
import Physiotherapy from './Pages/PhysiotherapyPage';
import Health from './Pages/YourHealth';
import Services from './Pages/Services';
import About from './Pages/About';
import Portfolio from './Pages/Portfolio';
import ProjectPage from './Pages/ProjectPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/work/:slug" element={<ProjectPage />} />
        <Route path="/physiotherapy" element={<Physiotherapy />} />
        <Route path="/health" element={<Health />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default App;